// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"26625dac73349e87a2b9","780":"a5c474ccae5ddf7e050a","838":"3a93e5e240b9f0d6b3d5"}[chunkId] + ".chunk.js";
};